import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { WelcomeHomepageModalComponent } from "./welcome-homepage-modal/welcome-homepage-modal.component";

@Component({
  selector: "app-new-homepage",
  templateUrl: "./new-homepage.component.html",
  styleUrls: ["./new-homepage.component.less"],
})
export class NewHomepageComponent implements OnDestroy {
  newUser: any;

  constructor(private activatedRoute: ActivatedRoute, private modalService: NgbModal) {
    var root = document.getElementsByTagName( 'html' )[0];
    root.setAttribute( 'class', 'relayHtmlClass' );
    this.activatedRoute.queryParams.subscribe((params) => {
      this.newUser = params["newUser"];
      if(this.newUser) {
        const locatorModalRef = this.modalService.open(
          WelcomeHomepageModalComponent,
          {
            ariaLabelledBy: "modal-basic-title",
            backdrop: true,
            windowClass: "confirm-modal",
            centered: true,
            size: "lg",
          }
        );
      }
    });
  }

  ngOnDestroy(): void {
    var root = document.getElementsByTagName( 'html' )[0];
    root.setAttribute( 'class', '' );
  }
}
